import { render, staticRenderFns } from "./streamerDialog.vue?vue&type=template&id=5da012c4"
import script from "./streamerDialog.vue?vue&type=script&lang=js"
export * from "./streamerDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports